export default __webpack_public_path__ + "static/media/total usages.597f530b.svg";